<div class="empty-result-container" [attr.data-testid]="testId">
  <div class="empty-result-content">
    <div class="empty-result-illustration" *ngIf="image">
      <img [src]="image" [alt]="title || 'Empty state'" class="empty-illustration" />
    </div>

    <div class="empty-result-text">
      <h2 class="empty-result-title" [attr.data-testid]="testId + '-title'" *ngIf="title">
        {{ title }}
      </h2>
      <p
        class="empty-result-description"
        [attr.data-testid]="testId + '-description'"
        *ngIf="description"
      >
        {{ description }}
      </p>
    </div>

    <div class="empty-result-action" *ngIf="showAction && actionText">
      <button
        class="empty-result-btn"
        [attr.data-testid]="testId + '-action-button'"
        (click)="onActionClick()"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4V16M4 10H16"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ actionText }}
      </button>
    </div>
  </div>
</div>
